<template>
  <div class="tuolele-main-box account-add">
    <el-form ref="form" :model="accountInfo" label-width="140px">
      <el-form-item label="选择店铺" required>
        <Checkbox
          :list.sync="shopList"
          :select-list="selectSchool"
          @updateCheck="updateCheck"
        />
      </el-form-item>
      <el-form-item v-if="type == 'add'" label="登录账号" required>
        <el-input
          v-model="accountInfo.username"
          clearable
          placeholder="例如：zhangshan"
        />
        <i style="color: brown;"> * 只能输入字母数字；3~25个字符</i>
      </el-form-item>

      <el-form-item v-if="type == 'add'" label="登录密码" required>
        <el-input
          v-model="accountInfo.password"
          clearable
          placeholder="请输入初始密码，系统支持修改登录密码"
        />
        <i style="color: brown;"> * 字母和数字，下划线_及破折号-；6~18个字符，可以直接复制给用户</i>
      </el-form-item>
      <el-form-item v-else label="账号" required>
        <el-input
          v-model="accountInfo.username"
          clearable
          :disabled="true"
        />
      </el-form-item>
      <el-form-item label="账号昵称" required>
        <el-input
          v-model="accountInfo.nickname"
          clearable
          placeholder="例如：托乐乐"
        />
      </el-form-item>

      <el-form-item label="账号角色" required>
        <el-select v-model="accountInfo.role_id" placeholder="请选择角色">
          <el-option
            v-for="(item, index) in obligationList"
            :key="index"
            :label="item.title"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="是否同步校区" required>
        <el-select v-model="accountInfo.synchro_status" placeholder="请选择">
          <el-option label="同步" value="2" />
          <el-option label="不同步" value="1" />
        </el-select>
      </el-form-item> -->
      <el-form-item class="form-buttom">
        <el-button
          type="primary"
          class="el-button-confirm"
          @click="accountImprove"
        >保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Checkbox from '@/components/toolbar/Checkbox.vue'
import Tool from '@/assets/js/tool.js'
export default {
  name: 'AccountAdd',
  components: {
    Checkbox,
  },
  data() {
    return {
      type: 'add',
      accountInfo: {
        shop_id: '',
        nickname: '',
        username: '',
        obligation_id: '',
        synchro_status: '',
        password: Tool.strongRandomString(8),
      },
      shopList: [],
      selectSchool: [],
      obligationList: []
    }
  },
  mounted() {
    this.type = this.$route.query.type
    this.accountInfo.uid = this.$route.query.uid
    if (this.accountInfo.uid) {
      this.getAccountInfo()
    }
    this.getObligationList()
    this.getMyShopList()
  },
  methods: {
    getObligationList() {
      this.$http.getObligationList().then(res => {
        this.obligationList = res.data
      })
    },
    getMyShopList() {
      this.$http.getShops().then(res => {
        this.shopList = []
        res.data.forEach(item => {
          this.shopList.push({
            text: item.name,
            value: item.id
          })
        })
      })
    },
    updateCheck(val) {
      this.selectSchool = val
      this.accountInfo.shop_id = val.join(',')
    },
    getAccountInfo() {
      this.$http.getAccountInfo({ uid: this.accountInfo.uid }).then(res => {
        this.accountInfo = res.data
        this.selectSchool = this.accountInfo.shop_id.split(',')
      })
    },
    accountImprove() {
      if (!this.accountInfo.shop_id) {
        this.$message({
          type: 'warning',
          message: '请选择店铺'
        })
        return
      }
      if (
        !this.accountInfo.shop_id ||
        !this.accountInfo.nickname ||
        !this.accountInfo.username ||
        !this.accountInfo.role_id
        // ||
        // !this.accountInfo.synchro_status
      ) {
        this.$message({
          type: 'warning',
          message: '请完善账号信息'
        })
        return
      }
      if (this.type == 'add' && !this.accountInfo.password) {
        this.$message({
          type: 'warning',
          message: '请填写账号初始密码'
        })
        return
      }
      this.$http.improveAccount(this.accountInfo).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>
<style lang="scss">
.account-add {
  .el-input,
  .el-textarea {
    width: 310px;
  }
  .form-buttom {
    .el-form-item__content {
      margin-left: 140px !important;
    }
  }
  .checkbox-item:first-child {
    width: 80px !important;
    margin-bottom: 20px;
  }
  .checkbox-item {
    width: 160px !important;
    margin-bottom: 20px;
  }
}
</style>
